import { Redirect } from 'react-router-dom'

import {
  EmptyComponent,
  ErrorComponent,
  LoadingComponent,
} from '~/components/Query/utils'
import * as routes from '~/constants/routes'
import { useUsersListQuery } from '~/gql/generated/graphql'
import { useCurrentScheme } from '~/hooks'

// Look up a user by their email address and redirect to their user page
const RedirectByEmail = ({ email }: { email: string }) => {
  const { currentSchemeId } = useCurrentScheme()
  const { data, loading, error } = useUsersListQuery({
    variables: {
      // ilike without wildcards is a case-insensitive exact match
      where: [{ email: { ilike: email.trim() } }],
      paginate: { page: 1, per_page: 1 },
    },
    pollInterval: 0,
    // The 'roles' field can error for some roles, but we only need the id
    errorPolicy: 'all',
  })

  if (loading) return <LoadingComponent />

  const userId = data?.table?.nodes?.[0]?.id
  if (!userId) {
    if (error) return <ErrorComponent error={error} />
    return <EmptyComponent text={`No user found with email ${email}`} />
  }

  const userPath = `${routes.USERS}/${userId}`
  return (
    <Redirect
      to={
        currentSchemeId
          ? routes.prependScheme(userPath, currentSchemeId)
          : userPath
      }
    />
  )
}

export default RedirectByEmail
